import React from 'react'
import { Backtotop, Floatinmenu, Underline } from "../../widgets";
import { useEffect } from 'react'
import { FaComputer } from "react-icons/fa6";
import { incubation_menu } from "../../constants/incubation";
import { RadialMenu, Listformat, Table, Heroimagecarousal } from "../../components";
import { onboarding_companies, incubation_img_corousal } from '../../constants/incubation'

const Onboarding_companies = () => {
    useEffect(() => {
        document.title = 'ACCET-CSE Department';
    }, []);

    const columns = [
        { field: "sno", header: "sno" },
        { field: "company_name", header: "Company Name" },
        { field: "focus", header: "Focus Sector" },

    ];

    return (
        <div className="incubationdept">
            <Heroimagecarousal
                key={incubation_img_corousal.id}
                title={incubation_img_corousal.title}
                img_list={incubation_img_corousal.img_list}
            />
            {/* <div className="incubationbg">
                <div className="incubationheading">
                    Alagappa Incubation Forum
                </div>
            </div> */}
            <section className="incubationdark">
                <div className="dept_float_menu">
                    <Floatinmenu logo={FaComputer} head="Menu" links={incubation_menu} />
                </div>
                <RadialMenu menu_links={incubation_menu} />
                
                <Underline heading="Onboarding Companies" />
                <div className='incubation_mentors_table'>

                    <Table data={onboarding_companies} columns={columns} />
                </div>
            </section>

            <Backtotop />
        </div>

    )
}

export default Onboarding_companies